import url from './url';



export default url(({ featureSource = ':featureSource', featureId = ':featureId' }) => `/${featureSource}/${featureId}`);
